module.exports = __webpack_public_path__ + "img/icon371.a2cfe7bd.png";